import { Popover, Typography, CircularProgress, Box, Divider, Chip, Dialog, Avatar } from '@mui/material'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import Scrollbars from 'react-custom-scrollbars-2'

import { connect } from 'react-redux'
import { getField, getFieldData, getTranslation } from '../../utils/utils'

import { GetScreenSize } from '../../utils/screenSize'
import { getSVG } from '../../utils/getSvg'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'


const Notifications = ({
    dictionary,
    language,
    id,
    open,
    anchorEl,
    handleClose,
    loading,
    notifications,
    translation,
    restaurantsBranches
}) => {
    const [restaurants, setRestaurants] = useState([])
    const [branches, setBranches] = useState([])
    useEffect(() => {
        let restaurants = []
        let branches = []
        if (restaurantsBranches && restaurantsBranches.length > 0) {
            restaurantsBranches.map(rest => {
                restaurants.push({
                    uuid: rest.uuid,
                    name: rest.name,
                })
            })
            restaurantsBranches.map(rest => {
                rest.branches.map(branch => {
                    branches.push({
                        uuid: branch.uuid,
                        name: branch.name,
                    })
                })
            })
        }
        setRestaurants(restaurants)
        setBranches(branches)
    }, [restaurantsBranches])
    const notrificationsDictionary = getTranslation('notifications', translation)
    const history = useHistory()
    const screenSize = GetScreenSize()

    const getRestaurantName = (notification) => {
        const restaurant = restaurants.find(rest => rest.uuid === notification.data.restaurantId)
        return restaurant ? getFieldData(restaurant, 'name', language) : ''
    }
    const getBranchName = (notification) => {
        const branch = branches.find(branch => branch.uuid === notification.data.branchId)
        return branch ? getFieldData(branch, 'name', language) : ''
    }
    const translateNotification = (notification) => {
        let title = ''
        switch (notification.page) {
            case 'order':
                switch (notification.data.type) {
                    case 'order-placed':
                        title = `${getField(notrificationsDictionary, 'you-have-order', language)} ${getRestaurantName(notification)} - ${getBranchName(notification)}`
                        break;
                    case 'order-canceled':
                        title = `${getField(notrificationsDictionary, 'order-canceled', language)} ${getRestaurantName(notification)} - ${getBranchName(notification)}`
                        break;
                    default:
                        title = null
                }
                break;
            case 'messages':
                switch (notification.data.type) {
                    case 'new-message':
                        title = `${getField(notrificationsDictionary, 'new-message', language)} ${notification.data.firstName} ${notification.data.lastName}`
                        break;
                    default:
                        title = null
                }
            default:
                title = notification.title
                break;
        }
        return title
    }
    if (screenSize.dynamicWidth > 677)
        return (
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <Box sx={{ width: 500, display: 'flex', justifyContent: 'center', minHeight: 300, alignItems: 'center' }} padding={2}>
                    {loading ?
                        <CircularProgress />
                        :
                        <Scrollbars autoHeight autoHeightMin={300} sx={{ width: '100%' }}>
                            {
                                notifications.length > 0 ?
                                    notifications.sort((a, b) => b.createdAt - a.createdAt).map((notification) => {
                                        return (
                                            <Box>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', backgroundColor: !notification.seenAt && 'background.default', cursor: 'pointer' }} padding={2}
                                                    onClick={() => {
                                                        let url = '/'
                                                        notification.data.clickAction.split('/').map((str, i) => {
                                                            if (i !== 0 && i !== 1 && i !== 2)
                                                                url += str + "/"
                                                        })


                                                        // Check if we're navigating to the same route with different params
                                                        const currentPath = history.location.pathname;
                                                        const basePath = currentPath.split('/').slice(0, 3).join('/');
                                                        const targetBasePath = url.split('/').slice(0, 3).join('/');

                                                        if (basePath === targetBasePath) {
                                                            // If same base path but different params, replace instead of push
                                                            history.replace(url);
                                                        } else {
                                                            // Different page, normal navigation
                                                            history.push(url);
                                                        }
                                                    }
                                                    }
                                                >
                                                    {notification.imageUrl && <Avatar
                                                        src={notification.imageUrl}
                                                        sx={{
                                                            width: 50,
                                                            height: 50,
                                                            marginRight: 2,
                                                            borderRadius: '4px' // This makes it square with slightly rounded corners
                                                        }}
                                                    />}
                                                    <Box sx={{ width: '70%' }}>
                                                        <Box sx={{ fontWeight: 700, fontSize: 14 }}>
                                                            {translateNotification(notification)}
                                                        </Box>
                                                        <Box>
                                                            {notification.description}
                                                        </Box>
                                                    </Box>
                                                    <Box sx={{ fontSize: 12 }}>
                                                        {moment(notification.createdAt).local().fromNow()}
                                                    </Box>

                                                </Box>
                                                <Divider />
                                            </Box>
                                        )
                                    })
                                    :
                                    <Box padding={2} sx={{ height: '300px', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'background.paper', borderRadius: '18px' }}>
                                        <Chip label={getField(dictionary, 'no-notifications', language)} sx={{ fontWeight: 'bold', fontSize: 14 }} />
                                    </Box>
                            }
                        </Scrollbars>
                    }
                </Box>
            </Popover>
        )
    else return (
        <Dialog open={Boolean(open)} fullScreen>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }} padding={2}>
                <Box onClick={handleClose}>
                    {getSVG('Close', null, { width: 25, height: 25 })}
                </Box>
            </Box>
            <Scrollbars autoHeight autoHeightMin={screenSize.dynamicHeight - 60} sx={{ width: '100%' }}>
                {
                    notifications.length > 0 ?
                        notifications.map((notification) => {
                            return (
                                <Box>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }} padding={2}>
                                        <Box sx={{ width: '70%' }}>
                                            <Box sx={{ fontWeight: 700 }}>
                                                {notification?.title}
                                            </Box>
                                            <Box>
                                                {notifications.description}
                                            </Box>
                                        </Box>
                                        <Box>
                                            {moment(notification.createdAt).local().fromNow()}
                                        </Box>

                                    </Box>
                                    <Divider />
                                </Box>
                            )
                        })
                        :
                        <Box padding={2} sx={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'background.paper', borderRadius: '18px' }}>
                            <Chip label={getField(dictionary, 'no-notifications', language)} sx={{ fontWeight: 'bold', fontSize: 14 }} />
                        </Box>
                }
            </Scrollbars>
        </Dialog>
    )
}
const mapStateToProps = (state) => ({
    loading: state.notifications.loading,
    notifications: state.notifications.notifications,
    translation: state.translation.translation,
    restaurantsBranches: state.user.restaurantsBranches
})
export default connect(mapStateToProps)(Notifications)